import { useEffect } from 'react';
import leftBgImage from '../assets/left-bg.png';
import rightBgImage from '../assets/right-bg.png';
import leftBgImage2 from '../assets/left-bg-2.png';
import rightBgImage2 from '../assets/right-bg-2.png';

const BackgroundEffect = () => {
  // Mouse background movement logic
  useEffect(() => {
    const handleMouseMove = (e) => {
      const { innerWidth, innerHeight } = window;
      const x = (e.clientX / innerWidth - 0.5) * 30;
      const y = (e.clientY / innerHeight - 0.5) * 30;

      const leftBg = document.querySelector('.left-bg');
      const rightBg = document.querySelector('.right-bg');

      if (leftBg) leftBg.style.transform = `translate(${x}px, ${y}px)`;
      if (rightBg) rightBg.style.transform = `translate(${x / 2}px, ${y / 2}px)`;
      const leftBg2 = document.querySelector('.left-bg-2');
      const rightBg2 = document.querySelector('.right-bg-2');

      if (leftBg2) leftBg2.style.transform = `translate(${x / 3}px, ${y / 3}px)`;
      if (rightBg2) rightBg2.style.transform = `translate(${x / 4}px, ${y / 4}px)`;
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  // Render background images
  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        overflow: 'hidden',
      }}
    >
      {/* First left image */}
      <div className="left-bg" style={{
        position: 'fixed',
        left: '-15%',
        top: '-10%',
        width: '50%',
        height: '150%',
        backgroundImage: `url(${leftBgImage})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left center',
        opacity: 1,
      }} />
      {/* Second left image */}
      <div className="left-bg-2" style={{
        position: 'fixed',
        left: '-25%',
        bottom: '-30%',
        width: '60%',
        height: '150%',
        backgroundImage: `url(${leftBgImage2})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left bottom',
        opacity: 0.7,
      }} />

      {/* First right image */}
      <div className="right-bg" style={{
        position: 'absolute',
        right: '-15%',
        top: '-15%',
        width: '50%',
        height: '150%',
        backgroundImage: `url(${rightBgImage})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right center',
        opacity: 1,
      }} />

      {/* Second right image */}
      <div className="right-bg-2" style={{
        position: 'absolute',
        right: '-25%',
        bottom: '-30%',
        width: '60%',
        height: '150%',
        backgroundImage: `url(${rightBgImage2})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right bottom',
        opacity: 0.7,
      }} />
    </div>
  );

};

export default BackgroundEffect;
